import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import palmTrees from '../../../assets/images/palmTrees.svg';
import { Container } from '../../../components/Newsletter/Banner/components/Container.js';
import { Graphic } from '../../../components/Newsletter/Banner/components/Graphic.js';
import { MaxWidthWrapper } from '../../../components/Newsletter/Banner/components/MaxWidthWrapper.js';
import { PartialText } from '../../../components/Newsletter/Banner/components/PartialText.js';
export const Banner = /*#__PURE__*/_styled(({
  headline,
  text,
  ...restProps
}) => {
  return _jsx(Container, {
    ...restProps,
    children: _jsxs(MaxWidthWrapper, {
      children: [headline && _jsx(PartialText, {
        children: headline
      }), text && _jsx(PartialText, {
        children: text
      }), _jsx(Graphic, {
        image: palmTrees,
        alt: ""
      })]
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e19yluej0"
} : {
  target: "e19yluej0",
  label: "Banner"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhbm5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTRyIsImZpbGUiOiJCYW5uZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCwganN4cyBhcyBfanN4cyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHBhbG1UcmVlcyBmcm9tICcuLi8uLi8uLi9hc3NldHMvaW1hZ2VzL3BhbG1UcmVlcy5zdmcnO1xuaW1wb3J0IHsgQ29udGFpbmVyIH0gZnJvbSAnLi4vLi4vLi4vY29tcG9uZW50cy9OZXdzbGV0dGVyL0Jhbm5lci9jb21wb25lbnRzL0NvbnRhaW5lci5qcyc7XG5pbXBvcnQgeyBHcmFwaGljIH0gZnJvbSAnLi4vLi4vLi4vY29tcG9uZW50cy9OZXdzbGV0dGVyL0Jhbm5lci9jb21wb25lbnRzL0dyYXBoaWMuanMnO1xuaW1wb3J0IHsgTWF4V2lkdGhXcmFwcGVyIH0gZnJvbSAnLi4vLi4vLi4vY29tcG9uZW50cy9OZXdzbGV0dGVyL0Jhbm5lci9jb21wb25lbnRzL01heFdpZHRoV3JhcHBlci5qcyc7XG5pbXBvcnQgeyBQYXJ0aWFsVGV4dCB9IGZyb20gJy4uLy4uLy4uL2NvbXBvbmVudHMvTmV3c2xldHRlci9CYW5uZXIvY29tcG9uZW50cy9QYXJ0aWFsVGV4dC5qcyc7XG5leHBvcnQgY29uc3QgQmFubmVyID0gc3R5bGVkKCh7IGhlYWRsaW5lLCB0ZXh0LCAuLi5yZXN0UHJvcHMgfSkgPT4ge1xuICAgIHJldHVybiAoX2pzeChDb250YWluZXIsIHsgLi4ucmVzdFByb3BzLCBjaGlsZHJlbjogX2pzeHMoTWF4V2lkdGhXcmFwcGVyLCB7IGNoaWxkcmVuOiBbaGVhZGxpbmUgJiYgX2pzeChQYXJ0aWFsVGV4dCwgeyBjaGlsZHJlbjogaGVhZGxpbmUgfSksIHRleHQgJiYgX2pzeChQYXJ0aWFsVGV4dCwgeyBjaGlsZHJlbjogdGV4dCB9KSwgX2pzeChHcmFwaGljLCB7IGltYWdlOiBwYWxtVHJlZXMsIGFsdDogXCJcIiB9KV0gfSkgfSkpO1xufSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1CYW5uZXIuanMubWFwIl19 */");